import { useContext } from 'react'
import { ThemeContext } from './context-base'

export function useTheme() {
  const ctx = useContext(ThemeContext)
  if (!ctx) {
    console.error('--- useTheme CALL FAILED: Context is null ---', { file: 'use-theme.ts' })
    throw new Error('useTheme must be used within a ThemeProvider')
  }
  return ctx
}
